import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAlertMessage } from "@microdoing/shared/services/profileSettings/selectors";
import { hideAlert } from "@microdoing/shared/services/profileSettings/actions";

import Toast from "../components/common/Toast";

const MessageAlert = () => {
  const { title = "", message = "", alertType = "" } = useSelector(
    getAlertMessage,
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideAlert());
  };

  return (
    <Toast
      title={title}
      message={message}
      alertType={alertType}
      onClose={handleClose}
    />
  );
};

export default MessageAlert;
